import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { Formio } from "@formio/js";
import { FormioProvider } from "@formio/react";
import { AdditionalComponentsModule } from "./module";
import App from "./components/App";
import { InfoPanelProvider } from "./hooks/useInfoPanelContext";
import "remixicon/fonts/remixicon.css";
const apiRoot = window.location.origin;
Formio.setBaseUrl(apiRoot);
Formio.setProjectUrl(apiRoot);
Formio.use(AdditionalComponentsModule);
const el = document.getElementById("root");
if (!el) {
    throw new Error("Root element not found");
}
const root = createRoot(el);
root.render(_jsx(StrictMode, { children: _jsx(FormioProvider, { Formio: Formio, baseUrl: " ", children: _jsx(InfoPanelProvider, { children: _jsx(App, {}) }) }) }));
